import React, { Component } from 'react';
import {
  Button,
  Col,
  Container,
  Form,
  FormGroup,
  Input,
  Label,
  Row } from 'reactstrap';

class Brochures extends Component {
  componentDidMount() {
    // Need to move page selector class up as a parent of .container-body so we can override .container-body max-width settings
    document.body.classList.add('page-brochures');
  }
  componentWillUnmount() {
    document.body.className = '';
  }
  render() {
    return (
      <div>
        <Container fluid>
          <Row>
            <Col md={6} className="brochures-img"></Col>
            <Col md={6} className="text-center brochure-content">
              <div className="max-container">
                <h2 className="mb-1 mb-md-2">Request Brochures</h2>
                <p className="mb-3 mb-md-4">If you need to order new printed brochures for your office please complete the form below</p>

                <Form>
                  <Container fluid>
                    <Row form>

                      <Col xs={12}>
                        <FormGroup className="dropdown-toggle">
                          <Label for="Specialty">Specialty</Label>
                          <Input type="select" name="select" id="Specialty">
                            <option value="">Select...</option>
                            <option value="audiology">Audiology</option>
                            <option value="bariatics">Bariatics</option>
                            <option value="chiropractic">Chiropractic</option>
                            <option value="cosmetic">Cosmetic Surgery</option>
                            <option value="dental">Dental</option>
                            <option value="dermatology">Dermatology</option>
                            <option value="fertility">Fertility</option>
                            <option value="general-healthcare">General Healthcare</option>
                            <option value="hair-restoration">Hair Restoration</option>
                            <option value="lasik-vision">Lasik &amp; Vision</option>
                            <option value="medical-devices">Medical Devices</option>
                            <option value="medspa">Medspa</option>
                            <option value="weight-loss">Weight Loss</option>
                          </Input>
                        </FormGroup>
                      </Col>
                      <Col lg={6}>
                        <FormGroup>
                          <Label for="fullName">Full Name</Label>
                          <Input type="text" name="full-name" id="fullName" />
                        </FormGroup>
                      </Col>
                      <Col lg={6}>
                        <FormGroup>
                          <Label for="businessName">Business Name</Label>
                          <Input type="text" name="business-name" id="businessName" />
                        </FormGroup>
                      </Col>
                      <Col lg={6}>
                        <FormGroup>
                          <Label for="Address">Address</Label>
                          <Input type="text" name="address" id="Address" />
                        </FormGroup>
                      </Col>
                      <Col lg={6}>
                        <FormGroup>
                          <Label for="Address2">Address 2</Label>
                          <Input type="text" name="address2" id="Address2" placeholder="Apartment, studio, or floor" />
                        </FormGroup>
                      </Col>
                      <Col lg={6}>
                        <FormGroup>
                          <Label for="City">City</Label>
                          <Input type="text" name="city" id="City" />
                        </FormGroup>
                      </Col>
                      <Col lg={6}>
                        <Row form>
                          <Col md={8}>
                            <FormGroup>
                              <Label for="State">State</Label>
                              <Input type="text" name="state" id="State" />
                            </FormGroup>
                          </Col>
                          <Col md={4}>
                            <FormGroup>
                              <Label for="Zip">Zip</Label>
                              <Input type="text" name="zip" id="Zip" className="pr-0" />
                            </FormGroup>
                          </Col>
                        </Row>
                      </Col>
                      <Col xs={12}>
                        <FormGroup className="dropdown-toggle">
                          <Label for="RequestType">Request Type</Label>
                          <Input type="select" name="request-type" id="RequestType">
                            <option value="">Select...</option>
                            <option value="audiology">First Order</option>
                            <option value="bariatics">Reorder</option>
                          </Input>
                        </FormGroup>
                      </Col>

                      <Col>
                        <Button color="primary" className="mt-3 mb-3">Request Brochures</Button>
                      </Col>

                    </Row>
                  </Container>
                </Form>
              </div>
            </Col>
          </Row>
        </Container>

      </div>
    );
  }
}

export default Brochures;
